import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, references } from '@apexdesigner/schema-tools';

export const processFunction = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .requiredFinal()
      .describe('Function name (e.g., formatCurrency)'),

    displayName: z
      .string()
      .nullable()
      .optional()
      .meta({ format: 'capitalCase' })
      .describe('Human-readable label'),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Description'),

    returnsArray: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether the function returns an array'),

    typescript: z
      .string()
      .nullable()
      .optional()
      .describe('TypeScript implementation of the function body'),

    returnTypeId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to ProcessDataType'),

    parameters: hasMany('ProcessFunctionParameter', 'functionId'),

    returnType: references('ProcessDataType'),
  })
  .describe('A helper function available in process expressions.')
  .as('ProcessFunction');

export { processFunction as processFunctionSchema };
